// @reducers
const RAAdditionalContributionReducer = require('./reducers/RAAdditionalContribution');
const RACancelPlanReducer = require('./reducers/RACancelPlan');
const RAAccountDetailsReducer = require('./reducers/RAAccountDetails');
const RACancelPeriodicContributionsReducer = require('./reducers/RACancelPeriodicContributions');
const RAAssociateObjectiveReducer = require('./reducers/RAAssociateObjective');
const RATimeHorizonCheckReducer = require('./reducers/RATimeHorizonCheck');
const RACheckStatusReducer = require('./reducers/RACheckStatus');
const RACustomPlanByObjectiveReducer = require('./reducers/RACustomPlanByObjective');
const RADissociateObjectiveReducer = require('./reducers/RADissociateObjective');
const RAGlobalPositionReducer = require('./reducers/RAGlobalPosition');
const RAHireManagementPlanReducer = require('./reducers/RAHireManagementPlan');
const RALastMovementReducer = require('./reducers/RALastMovement');
const RAPortfolioDistributionReducer = require('./reducers/RAPortfolioDistribution');
const RAPortfolioEvolutionReducer = require('./reducers/RAPortfolioEvolution');
const RARefundRequestReducer = require('./reducers/RARefundRequest');
const RASuitabilityTestReducer = require('./reducers/RASuitabilityTest');
const RAWizardReducer = require('./reducers/RAWizard');
const RAManagementPlanReducer = require('./reducers/RAManagementPlan');
const RASetGoalReducer = require('./reducers/RASetGoal');
const RAExpectedProfitabilityReducer = require('./reducers/RAExpectedProfitability');
const RAProjectionChartOjectiveTrackingReducer = require('./reducers/RAProjectionChartOjectiveTracking');
const RAEvolutionChartOjectiveTrackingReducer = require('./reducers/RAEvolutionChartOjectiveTracking');
const RAObjectiveDetailsReducer = require('./reducers/RAObjectiveDetails');
const RAPortfolioDetailsReducer = require('./reducers/RAPortfolioDetails');
const RAPortfoliosNameHistoryReducer = require('./reducers/RAPortfoliosNameHistory');
const RASimulationReducer = require('./reducers/RASimulation');
const RASaveSimulationReducer = require('./reducers/RASaveSimulation');
const RAReimbursementReducer = require('./reducers/RAReimbursement');
const RAAlertsReducer = require('./reducers/RAAlerts');
const RAFeatureFlagReducer = require('./reducers/RAFeatureFlag');

// @views
const RAAdditionalContributionView = require('./routes/RAAdditionalContributionView/RAAdditionalContributionView');
const RACancelPeriodicContributionsView = require('./routes/RACancelPeriodicContributionsView/RACancelPeriodicContributionsView');
const RACancelPlanView = require('./routes/RACancelPlanView/RACancelPlanView');
const RACustomPlanByObjectiveView = require('./routes/RACustomPlanByObjectiveView/RACustomPlanByObjectiveView');
const RAHireManagementPlanView = require('./routes/RAHireManagementPlanView/RAHireManagementPlanView');
const RAHireWrapperView = require('./routes/RAHireWrapperView/RAHireWrapperView');
const RAGoalDistributionView = require('./routes/RAGoalDistributionView/RAGoalDistributionView');
const RAGoalWrapperView = require('./routes/RAGoalWrapperView/RAGoalWrapperView');
const RALastMovementsView = require('./routes/RALastMovementsView/RALastMovementsView');
const RAManagementPlanView = require('./routes/RAManagementPlanView/RAManagementPlanView');
const RAModifyPlanView = require('./routes/RAModifyPlanView/RAModifyPlanView');
const RAReimbursementView = require('./routes/RAReimbursementView/RAReimbursementView');
const RASetGoalView = require('./routes/RASetGoalView/RASetGoalView');
const RASuitabilityTestView = require('./routes/RASuitabilityTestView/RASuitabilityTestView');
const RASuitabilityTestStatusView = require('./routes/RASuitabilityTestStatusView/RASuitabilityTestStatusView');
const RAWrapperView = require('./routes/RAWrapperView/RAWrapperView');
const RAPortfolioDistributionView = require('./routes/RAPortfolioDistributionView/RAPortfolioDistributionView');
const RAObjectiveTrackingView = require('./routes/RAObjectiveTrackingView/RAObjectiveTrackingView');
const RAPortfolioTrackingView = require('./routes/RAPortfolioTrackingView/RAPortfolioTrackingView');
const RAAccountDetailsView = require('./routes/RAAccountDetailsView/RAAccountDetailsView');
const RAAssociateObjectiveView = require('./routes/RAAssociateObjectiveView/RAAssociateObjectiveView');
const RADissociateObjectiveView = require('./routes/RADissociateObjectiveView/RADissociateObjectiveView');

// @components
const RAGlobalPosition = require('./components/RAGlobalPosition/RAGlobalPosition');
const RAOKCover = require('./components/commons/RAOKCover/RAOKCover');
const RANonresidentialModal = require('./components/RANonresidentialModal/RANonresidentialModal');
const RAPatrimonyDetails = require('./components/RAPatrimonyDetails/RAPatrimonyDetails');
const RAToggle = require('./components/RAToggle/RAToggle');
const RAFeatureFlagModal = require('./components/RAFeatureFlagModal/RAFeatureFlagModal');
const RAFaq = require('./components/RAFaq/RAFaq');
const RATestExpirationDisclaimer = require('./components/RATestExpirationDisclaimer/RATestExpirationDisclaimer');
// @actions
const raTimeHorizonCheckActions = require('./actions/RATimeHorizonCheck');
const raCheckStatusActions = require('./actions/RACheckStatus');
const raExpectedProfitabilityActions = require('./actions/RAExpectedProfitability');
const raLastMovementActions = require('./actions/RALastMovement');
const raManagementPlanActions = require('./actions/RAManagementPlan');
const raPortfolioDistributionActions = require('./actions/RAPortfolioDistribution');
const raPortfolioEvolutionActions = require('./actions/RAPortfolioEvolution');
const raSetGoalActions = require('./actions/RASetGoal');
const raSuitabilityTestActions = require('./actions/RASuitabilityTest');
const raSimulationActions = require('./actions/RASimulation');
const raSaveSimulationActions = require('./actions/RASaveSimulation');
const RAProjectionChartOjectiveTrackingActions = require('./actions/RAProjectionChartOjectiveTracking');
const raFeatureFlagActions = require('./actions/RAFeatureFlag');
// TEST

// @constants
const constants = require('./raConstants/index');

module.exports = {
    //Reducers
    RAAdditionalContributionReducer,
    RAAlertsReducer,
    RAFeatureFlagReducer,
    RACancelPeriodicContributionsReducer,
    RACancelPlanReducer,
    RAAccountDetailsReducer,
    RATimeHorizonCheckReducer,
    RACheckStatusReducer,
    RACustomPlanByObjectiveReducer,
    RAGlobalPositionReducer,
    RAHireManagementPlanReducer,
    RALastMovementReducer,
    RAPortfolioDistributionReducer,
    RAPortfolioEvolutionReducer,
    RARefundRequestReducer,
    RASetGoalReducer,
    RAWizardReducer,
    RASuitabilityTestReducer,
    RAManagementPlanReducer,
    RAExpectedProfitabilityReducer,
    RAProjectionChartOjectiveTrackingReducer,
    RAEvolutionChartOjectiveTrackingReducer,
    RAObjectiveDetailsReducer,
    RAPortfolioDetailsReducer,
    RAPortfoliosNameHistoryReducer,
    RASimulationReducer,
    RASaveSimulationReducer,
    RAReimbursementReducer,
    RAAssociateObjectiveReducer,
    RADissociateObjectiveReducer,
    //Views
    RAAdditionalContributionView,
    RACancelPeriodicContributionsView,
    RACancelPlanView,
    RACustomPlanByObjectiveView,
    RAHireManagementPlanView,
    RAHireWrapperView,
    RAGlobalPosition,
    RAGoalDistributionView,
    RAGoalWrapperView,
    RALastMovementsView,
    RAManagementPlanView,
    RAModifyPlanView,
    RAReimbursementView,
    RASetGoalView,
    RASuitabilityTestView,
    RASuitabilityTestStatusView,
    RAWrapperView,
    RAPortfolioDistributionView,
    RAObjectiveTrackingView,
    RAPortfolioTrackingView,
    RAAccountDetailsView,
    RAAssociateObjectiveView,
    RADissociateObjectiveView,
    //Components
    RAOKCover,
    RANonresidentialModal,
    RAPatrimonyDetails,
    RAToggle,
    RAFeatureFlagModal,
    RAFaq,
    RATestExpirationDisclaimer,
    //Actions
    raTimeHorizonCheckActions,
    raCheckStatusActions,
    raFeatureFlagActions,
    raExpectedProfitabilityActions,
    raLastMovementActions,
    raManagementPlanActions,
    raPortfolioDistributionActions,
    raPortfolioEvolutionActions,
    raSetGoalActions,
    raSuitabilityTestActions,
    raSimulationActions,
    raSaveSimulationActions,
    RAProjectionChartOjectiveTrackingActions,
    //Constants
    constants,
};
